import { areBothMissing } from '../shared.js';

const areSameOpticianDetails = (server, draft)=>{
    if (areBothMissing(draft.opticianDetails, server.opticianDetails)) {
        // If they're both missing we consider them equal
        return true;
    } else if (!draft.opticianDetails || !server.opticianDetails) {
        // If one of them is missing we consider them to not be equal
        return false;
    }
    for (const field of Object.getOwnPropertyNames(draft.opticianDetails)){
        const serverValue = server.opticianDetails[field];
        const draftValue = draft.opticianDetails[field];
        /**
     * If server and client both express in their own way that
     * the value is missing, we consider them to be equal.
     */ if (areBothMissing(serverValue, draftValue)) {
            continue;
        }
        if (serverValue !== draftValue) {
            return false;
        }
    }
    return true;
};

export { areSameOpticianDetails };
//# sourceMappingURL=optician-details.js.map
